import { api, ApiRequestConfig } from 'api';
import { PostReviewRequest, PostReviewResponse } from './post-review-types';

/**
 * Запрос на создание нового отзыва
 * @param {string} regionCode
 * @param {PostReviewRequest} review
 * @returns {Promise<PostReviewResponse>}
 */
export const postReviewAction = (
  regionCode: string,
  review: PostReviewRequest,
  config: ApiRequestConfig,
): Promise<PostReviewResponse> => {
  return api.post<PostReviewResponse>(
    'send-review',
    review,
    config,
    { regionCode }
  );
};
